<!--
   Created by qing on 2020/8/20
   Des: 
-->
<template>
  <div class="page-dash-container">
    <iframe
      :src="dashSrc"
      width="100%"
      height="100%"
      frameborder="0">
    </iframe>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        dashSrc: ''
      }
    },
    created() {
      this.$store.dispatch('actionNodeSave', {
        companyId: this.$store.getters.currentCompanyId,
        userId: this.$store.getters.userId,
        appId: this.$route.query.appId,
        dashboardId: this.$route.query.dashId,
        token: this.$store.state.token,
        env: this.$store.getters.env
      }).then(res => {
        if (process.env.NODE_ENV === 'production') {
          this.dashSrc = `${location.origin}${this.$DS_BASE_PATH}/#/dashboard?key=${res.nodeKey}`
        } else {
          this.dashSrc = `https://node.dev.161.54188.online/miniappds/#/dashboard?key=${res.nodeKey}`
        }
      }).catch(console.error)
    },
    methods: {}
  }
</script>

<style lang="less">

  .page-dash-container {
    height: 100%;
  }
</style>